export const blueConf =
  ['#03fcf8', '#0ec4c1', '#1290a3', '#49aef2', '#189cf5',
    '#1844f5', '#0535f5', '#041e85', '#000000']

export const redConf =
  ['#ff0000', '#a81313', '#d64545', '#e36212', '#e3af12', '#e312d2',
    '#bf2c96', '#f76383', '#c91818']

export const items = ['apple', 'plane', 'undertaker', 'orange', 'bark',
  'mango', 'dog', 'piano', 'unicorn', 'fly',
  'strike', 'bug', 'part', 'ship', 'australia',
  'war', 'mount', 'torch', 'march', 'pound',
  'diamond', 'bold', 'crash', 'stock', 'buck']